import { render, staticRenderFns } from "./Taxjar.vue?vue&type=template&id=42985228&scoped=true"
import script from "./Taxjar.vue?vue&type=script&lang=js"
export * from "./Taxjar.vue?vue&type=script&lang=js"
import style0 from "./Taxjar.vue?vue&type=style&index=0&id=42985228&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "42985228",
  null
  
)

export default component.exports